import $ from 'jquery';
import debounce from 'lodash/debounce';
//import toastr from 'toastr';

export default class {
  constructor(el) {
    const self = this;
    const submitContactSuccess = $('.submit-contact-success');
    const submitContactError = $('.submit-contact-error');
    self.$el = $(el);
    self.toggle = debounce(function(){
      $("body").toggleClass('has-contact-open');
    }, 150);

    $("body").on("click", (event) => {
      if($("body").hasClass("has-contact-open")){
        self.toggle();
        event.preventDefault();
      }
    });

    if (submitContactSuccess.length) {
      $('.closebtn', submitContactSuccess).click(function (e) {
        e.preventDefault();
        submitContactSuccess.hide();
      })
    }
    if (submitContactError.length) {
      $('.closebtn', submitContactError).click(function (e) {
        e.preventDefault();
        submitContactError.hide();
      })
    }

    self.$el.on("click", (event) => {
      event.stopPropagation();
    });

    $('.js-contact__toggle, [href="#contact"]').on("click", (event) => {
      self.toggle();
      event.preventDefault();
    });

    self.$el.find(".js-contact__send").on('click', function(event) {
      var empty = false;
      var checkboxIsEmpty = true;
      event.preventDefault();
      self.$el.removeClass('error');
      self.$el.find("input, textarea").parent().removeClass('empty');
      self.$phone = self.$el.find('input[name="tel"]').first();
      self.$mail = self.$el.find('input[name="email"]').first();
      self.$rgpd = self.$el.find('input[name="privacy-policy"]').first();
      self.$errormsg = self.$el.find('.js-error-msg').first();
      self.$errormsg.html('Informations manquantes');
      self.$el.find("input, textarea").each((item,element) => {
        if($(element).val() == ''){
          $(element).parent().addClass('empty');
          self.$el.addClass('error');
          empty = true;
        }
      });
      if(!empty){
        let topics = self.$el.find('input[name="topic[]"]');
        if (topics.length > 0) {
          topics.each((item,element) => {
            if($(element).attr("checked")){
              checkboxIsEmpty = false;
            }
          });
        } else {
          checkboxIsEmpty = false;
        }
        if(checkboxIsEmpty){
          $('.c-contact__checkboxes__inputs').first().addClass('empty');
          self.$el.addClass('error');
        }
        empty = checkboxIsEmpty;
      }
      if(!empty){
        if(!$.isNumeric(self.$phone.val())){
          self.$phone.parent().addClass('empty');
          self.$el.addClass('error');
          empty = true;
          self.$errormsg.html('Le numéro doit être composé de chiffres');
        }
      }
      if(!empty){
        if(!validateEmail(self.$mail.val())){
          self.$mail.parent().addClass('empty');
          self.$el.addClass('error');
          empty = true;
          self.$errormsg.html('E-mail non valide');
        }
      }
      if(!empty){
        if(!self.$rgpd.prop("checked")){
          self.$rgpd.parent().addClass('empty');
          self.$el.addClass('error');
          self.$errormsg.html("Vous devez acceptez d'être recontacté");
          empty = true;
        }
      }
      if(!empty){
        $.proxy(self.send, self)();
      }
    });
    function validateEmail(sEmail) {
      const filter = /^\b[A-Z0-9._%-+]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
      if (filter.test(sEmail)) {
        return true;
      }
      return false;
    }
  }
  send() {
    const self = this;
    const submitContactSuccess = $('.submit-contact-success');
    const submitContactError = $('.submit-contact-error');
    $.post(window.proximy.ajax, `${self.$el.serialize()}&action=proximy_contact`).success((data) => {
      self.toggle();
      if (data.mail_sent) {
        if (submitContactSuccess.length) {
          submitContactSuccess.show();
        }
      } else {
        if (submitContactError.length) {
          submitContactError.show();
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Contact.js